import { Check, Loader2, WifiOff, Cloud } from 'lucide-react';

/**
 * Subtle save status indicator.
 * saveStatus: 'idle' | 'saving' | 'saved' | 'error' | 'offline'
 */
export function SaveIndicator({ saveStatus }) {
  if (saveStatus === 'idle') return null;

  return (
    <div className="flex items-center gap-1.5 text-xs transition-opacity duration-300" data-testid="save-indicator">
      {saveStatus === 'saving' && (
        <>
          <Loader2 className="h-3 w-3 animate-spin text-primary/70" />
          <span className="text-muted-foreground">Saving...</span>
        </>
      )}
      {saveStatus === 'saved' && (
        <>
          <Check className="h-3 w-3 text-green-500" />
          <span className="text-green-500/80">Saved</span>
        </>
      )}
      {saveStatus === 'offline' && (
        <>
          <WifiOff className="h-3 w-3 text-amber-500" />
          <span className="text-amber-500/80">Saved locally</span>
        </>
      )}
      {saveStatus === 'error' && (
        <>
          <Cloud className="h-3 w-3 text-red-400" />
          <span className="text-red-400/80">Save failed</span>
        </>
      )}
    </div>
  );
}
